// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../library/style/breakpoint.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../library/style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tKygQ4LMDikHs5Hsh0Qk {
  width: 100%;
  height: 75px;
  z-index: 100;

  background-color: white;
  box-shadow: 0px 1px 15px #F5F8FD;
}

.RHJ9fyGU3xJGSIiej7t2 {
  max-width: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["desktop"]};
  height: 75px;
  margin: auto;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.gavGwzqIpCkVEAJgxswL {
  display: flex;
  align-items: center;
}

.fUnS8BXXQeLUzup7jb9J {
  margin: 0;

  font-family: Fjalla One;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  letter-spacing: 0.005em;
  text-transform: uppercase;
}

.vCTAvDQevbIGSPjw6Lv0 {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-left: 16px;
}

.VT7vrIbFRCSjs6mrLoSQ {
  text-decoration: none;
  color: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-text-subtle"]};
  pointer-events: none;
  font-size: 16px;
}

.VMEEL2Y2r_Mr0hzwjSgA {
  color: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-purple"]};
}

.JEy1mpMxOmIACcQpl6Td {
  color: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-text-subtle"]};
  font-size: 14px !important;
  width: 26px !important;
}

.L12fOZ9wePssfRstndeg {
  height: 16px;
  margin-right: 8px;
}

.uh77wlmcWmaqnLne3BlO {
  color: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-text-subtle"]};
  font-size: 16px;
}

.vL4kBD01WOQl7ZZ5bIZp {
  font-weight: 500;
  margin-left: 4px;
  font-size: 16px;
}

@media screen and (max-width: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["desktop"]}) {
  .RHJ9fyGU3xJGSIiej7t2 {
    width: 90%;
  }
}

@media screen and (max-width: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet"]}) {
  .CpeVlPtGzYSPpxeGkGHO {
    display: none;
  }

  .tKygQ4LMDikHs5Hsh0Qk {
    position: fixed;
  }

  .VT7vrIbFRCSjs6mrLoSQ {
    font-size: 12px;
  }

  .fUnS8BXXQeLUzup7jb9J {
    margin-right: 8px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Navigation/Navigation.module.css"],"names":[],"mappings":"AAMA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;;EAEZ,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,uDAAkB;EAClB,YAAY;EACZ,YAAY;;EAEZ,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAS;;EAET,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,mDAAwB;EACxB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,mDAAmB;AACrB;;AAEA;EACE,mDAAwB;EACxB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,mDAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["@value breakpoints: \"../library/style/breakpoint.css\";\n@value desktop, mobile-xs, tablet, mobile from breakpoints;\n\n@value colors: \"../library/style/colors.css\";\n@value color-purple, color-text-subtle from colors;\n\n.navigation {\n  width: 100%;\n  height: 75px;\n  z-index: 100;\n\n  background-color: white;\n  box-shadow: 0px 1px 15px #F5F8FD;\n}\n\n.content {\n  max-width: desktop;\n  height: 75px;\n  margin: auto;\n\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.row {\n  display: flex;\n  align-items: center;\n}\n\n.logo {\n  margin: 0;\n\n  font-family: Fjalla One;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 24px;\n  letter-spacing: 0.005em;\n  text-transform: uppercase;\n}\n\n.navigationLink {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  margin-left: 16px;\n}\n\n.link {\n  text-decoration: none;\n  color: color-text-subtle;\n  pointer-events: none;\n  font-size: 16px;\n}\n\n.active {\n  color: color-purple;\n}\n\n.icon {\n  color: color-text-subtle;\n  font-size: 14px !important;\n  width: 26px !important;\n}\n\n.flag {\n  height: 16px;\n  margin-right: 8px;\n}\n\n.problem {\n  color: color-text-subtle;\n  font-size: 16px;\n}\n\n.phone {\n  font-weight: 500;\n  margin-left: 4px;\n  font-size: 16px;\n}\n\n@media screen and (max-width: desktop) {\n  .content {\n    width: 90%;\n  }\n}\n\n@media screen and (max-width: tablet) {\n  .hideDesktop {\n    display: none;\n  }\n\n  .navigation {\n    position: fixed;\n  }\n\n  .link {\n    font-size: 12px;\n  }\n\n  .logo {\n    margin-right: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"breakpoints": `"../library/style/breakpoint.css"`,
	"desktop": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["desktop"]}`,
	"mobile-xs": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["mobile-xs"]}`,
	"tablet": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["tablet"]}`,
	"mobile": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["mobile"]}`,
	"colors": `"../library/style/colors.css"`,
	"color-purple": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-purple"]}`,
	"color-text-subtle": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["color-text-subtle"]}`,
	"navigation": `tKygQ4LMDikHs5Hsh0Qk`,
	"content": `RHJ9fyGU3xJGSIiej7t2`,
	"row": `gavGwzqIpCkVEAJgxswL`,
	"logo": `fUnS8BXXQeLUzup7jb9J`,
	"navigationLink": `vCTAvDQevbIGSPjw6Lv0`,
	"link": `VT7vrIbFRCSjs6mrLoSQ`,
	"active": `VMEEL2Y2r_Mr0hzwjSgA`,
	"icon": `JEy1mpMxOmIACcQpl6Td`,
	"flag": `L12fOZ9wePssfRstndeg`,
	"problem": `uh77wlmcWmaqnLne3BlO`,
	"phone": `vL4kBD01WOQl7ZZ5bIZp`,
	"hideDesktop": `CpeVlPtGzYSPpxeGkGHO`
};
export default ___CSS_LOADER_EXPORT___;
